module.exports = __webpack_public_path__ + "img/check-square.f1cd6704.svg";